import { BaseProduct, ProductBuilderMachineContext } from '../types';
import { productHasColour } from './colour';

import { getVariantOptionKeyForBladeSize } from './bladeSize';

type GetOperation = (context: ProductBuilderMachineContext) => string[];
type ProductHasOperationOption = (product: BaseProduct) => boolean;
type GetVariantOptionKeyForOperation = (
  product: BaseProduct,
) => OperationKey | null;

type OperationKey = 'option1' | 'option2' | 'option3';
type ProductHasVariantWithOperation = (
  operation: string,
) => (product: BaseProduct) => boolean;

export const productHasOperationOption: ProductHasOperationOption = product =>
  product.options.includes('Operation');

export const getVariantOptionKeyForOperation: GetVariantOptionKeyForOperation = product => {
  const operationIndex = product.options.findIndex(
    option => option === 'Operation',
  );
  if (operationIndex === -1) return null;

  return `option${operationIndex + 1}` as OperationKey;
};

export const getOperation: GetOperation = context => {
  const {
    products,
    custom: { colour, bladeSize },
  } = context;

  const productsWithOption = products.filter(product =>
    productHasColour(colour)(product),
  );

  if (productsWithOption.length === 0) {
    return [];
  }
  const operationKey = getVariantOptionKeyForOperation(productsWithOption[0]);
  const bladeSizeKey = getVariantOptionKeyForBladeSize(productsWithOption[0]);
  if (operationKey === null || bladeSizeKey === null) return [];

  return Array.from(
    new Set(
      productsWithOption
        .map(({ variants }) =>
          variants
            .filter(variant => variant[bladeSizeKey] === bladeSize)
            .map(variant => {
              return variant[operationKey] as string;
            }),
        )
        .flat(),
    ),
  );
};

export const productHasVariantWithOperation: ProductHasVariantWithOperation = operation => product => {
  const optionKey = getVariantOptionKeyForOperation(product);
  if (optionKey === null) return false;

  return product.variants.some(variant => variant[optionKey] === operation);
};
